export type Langs = {
  [key: string]: string
}
export const langs: Langs = {
  en: 'en-us',
  pt: 'pt-br',
}
